var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinsDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 37.5013C38.3715 37.5013 45.8333 30.0394 45.8333 20.8346C45.8333 11.6299 38.3715 4.16797 29.1667 4.16797C19.9619 4.16797 12.5 11.6299 12.5 20.8346C12.5 30.0394 19.9619 37.5013 29.1667 37.5013Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57554 22.918C5.05191 25.2463 4.16602 28.0294 4.16602 31.0196C4.16602 39.2017 10.7989 45.8346 18.9809 45.8346C21.9712 45.8346 24.7544 44.9488 27.0827 43.425",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8565 17.0933C32.4062 15.193 30.1136 13.4783 27.3617 14.7611C24.6099 16.0439 24.1727 20.1713 28.3353 20.6098C30.2166 20.808 31.4433 20.3798 32.5663 21.5909C33.6893 22.8019 33.8979 26.1699 31.027 27.0776C28.1562 27.9853 25.3135 26.567 25.0039 24.5532M29.1377 12.5078V14.3183M29.1377 27.357V29.1745",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsDollar);
export default __webpack_public_path__ + "static/media/coins-dollar.32718f755097251a25bc59e087a4855a.svg";
export { ForwardRef as ReactComponent };